#import "../../../graphql/fragments/edition-fragment.graphql"

mutation UpdateBroadcast($edition: EditionUpdateInput!) {
    editionUpdate(input: $edition) {
        edition {
            ...EditionFragment
        }
    }
}
